
<modal
  title="Add Sale"
  size="side"
  :open="open"
  @close="closeModal"
>
  <div v-if="display === 'start'">
    <div class="grid">
      <cta-card
        icon="content_paste"
        title="Paste eBay Item ID"
        description="Paste in the eBay Item ID of missing sales to add them to the Sales History."
        @click="display = 'ebay'"
      />

      <cta-card
        v-if="isStaff"
        icon="file_upload"
        title="Admin Manual Sale"
        description="Admins can use this to manually add a sale to the Sales History."
        @click="addManualSale"
      />

      <cta-card
        icon="add"
        title="Submit Private Sale"
        description="Submit a private sale for approval."
        @click="submitPrivateSale"
      />
    </div>
  </div>

  <form v-if="display === 'ebay'" @submit.stop.prevent="submitEbay">
    <text-input
      v-model.trim="ebayItemId"
      label="eBay Item ID"
    />

    <div class="button-row">
      <btn
        type="submit"
        :loading="submitting"
        :disabled="disabled"
        loading-text="Submitting"
      >
        Submit
      </btn>

      <btn kind="secondary" @click="display = 'start'">
        Back
      </btn>
    </div>
  </form>
</modal>
